import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DataService } from '../../services/data.service';
import { Observable } from 'rxjs';
import { Q1Store } from '../../interfaces/game.interface';

@Component({
  selector: 'app-shop-tile',
  templateUrl: './shop-tile.component.html',
  styleUrls: ['./shop-tile.component.scss']
})
export class ShopTileComponent implements OnInit, OnChanges {
  @Input() shopId: string;
  shopDetails$: Observable<Q1Store>;

  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    this.shopDetails$ = this.dataService.getShopObservable(this.shopId);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.shopId) {
      this.shopDetails$ = this.dataService.getShopObservable(this.shopId);
    }
  }

  selectShop(shop: Q1Store) {
    this.dataService.selectShop(this.shopId);
  }

  deselectShop(shop: Q1Store) {
    this.dataService.deselectShop(this.shopId);
  }

  getColor(name: string) {
    let districtMap = {
      "Retail": {
        color: '#00D6E0',
        colorName: 'blue'
      },
      "University": {
        color: '#FF8100',
        colorName: 'orange'
      },
      "Industrial": {
        color: '#EA4E6C',
        colorName: 'pink'
      },
      "Suburban": {
        color: '#00D398',
        colorName: 'green'
      },
      "Shopping Centre": {
        color: '#F15B3D',
        colorName: 'red'
      }
    }
    return districtMap[name].color;
  }
}
